export const capexMock = {
    title: 'Capex 2022 ACT vs BGT',
    type: 'CAPEX',
    navigation: {
        type: 'GraphViews',
        nav: [
            {
                title: 'C',
                graph: {
                    data: [
                        {
                            budget: 100,
                            actual: 203,
                            budgetDeltaNumber: 23,
                            budgetDeltaPercent: 46,
                            isOverBudget: true,
                            title: 'Jan YTD Budget',
                            isActive: true,
                            isDefault: false
                        },
                        {
                            budget: 124,
                            actual: 100,
                            budgetDeltaNumber: 12,
                            budgetDeltaPercent: 63,
                            isOverBudget: true,
                            title: 'Fab YTD Budget',
                            isActive: true,
                            isDefault: true
                        },
                        {
                            budget: 200,
                            actual: 86,
                            budgetDeltaNumber: 21,
                            budgetDeltaPercent: 45,
                            isOverBudget: true,
                            title: 'Mar YTD Budget',
                            isActive: true,
                            isDefault: false
                        },
                        {
                            budget: 95,
                            actual: 30,
                            budgetDeltaNumber: 45,
                            budgetDeltaPercent: 46,
                            isOverBudget: false,
                            title: 'Apr YTD Budget',
                            isActive: true,
                            isDefault: false
                        },
                        {
                            budget: 100,
                            actual: 203,
                            budgetDeltaNumber: 23,
                            budgetDeltaPercent: 46,
                            isOverBudget: true,
                            title: 'May YTD Budget',
                            isActive: true,
                            isDefault: false

                        },
                        {
                            budget: 124,
                            actual: 100,
                            budgetDeltaNumber: 12,
                            budgetDeltaPercent: 63,
                            isOverBudget: true,
                            title: 'Jun YTD Budget',
                            isActive: true,
                            isDefault: false

                        },
                        {
                            budget: 200,
                            actual: 86,
                            budgetDeltaNumber: 21,
                            budgetDeltaPercent: 45,
                            isOverBudget: true,
                            title: 'Jul YTD Budget',
                            isActive: true,
                            isDefault: false

                        },
                        {
                            budget: 95,
                            actual: 30,
                            budgetDeltaNumber: 45,
                            budgetDeltaPercent: 46,
                            isOverBudget: false,
                            title: 'Aug YTD Budget',
                            isActive: true,
                            isDefault: false

                        },
                        {
                            budget: 250,
                            actual: 203,
                            budgetDeltaNumber: 23,
                            budgetDeltaPercent: 46,
                            isOverBudget: true,
                            title: 'Sep YTD Budget',
                            isActive: false,
                            isDefault: false
                        },
                        {
                            budget: 110,
                            actual: 100,
                            budgetDeltaNumber: 12,
                            budgetDeltaPercent: 63,
                            isOverBudget: true,
                            title: 'Oct YTD Budget',
                            isActive: false,
                            isDefault: false
                        },
                        {
                            budget: 89,
                            actual: 86,
                            budgetDeltaNumber: 21,
                            budgetDeltaPercent: 45,
                            isOverBudget: true,
                            title: 'Nov YTD Budget',
                            isActive: false,
                            isDefault: false
                        },
                        {
                            budget: 35,
                            actual: 30,
                            budgetDeltaNumber: 45,
                            budgetDeltaPercent: 46,
                            isOverBudget: false,
                            title: 'Dec YTD Budget',
                            isActive: false,
                            isDefault: false
                        },
                    ]
                }
            }
        ]
    }
}